import { useCallback } from 'react';

export function useSearchOnEnter(onSearch: () => void) {
  return useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        onSearch();
      }
    },
    [onSearch]
  );
}
